import { createTheme } from '@mui/material/styles';
import { grey, primary } from './colors';
const theme = createTheme();

/**
 * Typography
 * https://lumahealth.clickup.com/t/864egg6k5
 *
 * Demos:
 *
 * - [Typography](https://ui-packages.isbuildingluma.com/ui-core/react-typography/)
 *
 * API:
 *
 * - [Typography API](https://ui-packages.isbuildingluma.com/ui-core/api/typography/)
 * - inherits [MuiTypography API](https://mui.com/material-ui/api/typography/)
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/file/N3gFGSM48EkhCahScVFcoK/Luma-Patient-Design-System?node-id=929%3A7690&mode=dev)
 * - [Proto](https://bhdgwebdesignsa.z22.web.core.windows.net/text-styles.html)
 */
const typography = {
  fontFamily: '"Effra", sans-serif',
  h1: {
    // H1b / Effra Regular
    fontFamily: '"Effra", sans-serif',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(35),
    lineHeight: '43px',
    color: primary.main
  },
  h2: {
    // H2b / Effra Regular
    fontFamily: '"Effra", sans-serif',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(25),
    lineHeight: '27px',
    color: primary.main
  },
  h3: {
    // H3b / Effra Bold
    fontFamily: '"Effra", sans-serif',
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(19),
    lineHeight: '23px',
    letterSpacing: '0.22px',
    color: grey[800]
  },
  subtitle1: {
    fontFamily: '"Effra", sans-serif',
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(17),
    lineHeight: '20px',
    letterSpacing: '0.15px'
  },
  subtitle2: {
    fontFamily: '"Effra", sans-serif',
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(15),
    lineHeight: '18px',
    letterSpacing: '0.15px'
  },
  body1: {
    fontFamily: '"Effra", sans-serif',
    fontSize: theme.typography.pxToRem(17),
    lineHeight: '25px',
    letterSpacing: '0.49px'
  },
  body2: {
    fontFamily: '"Effra", sans-serif',
    fontSize: theme.typography.pxToRem(15),
    lineHeight: '23px',
    letterSpacing: '0.25px'
  },
  caption: {
    fontFamily: '"Effra", sans-serif',
    fontSize: theme.typography.pxToRem(13),
    lineHeight: '17px',
    letterSpacing: '0.4px'
  },
  button: {
    fontFamily: '"Effra", sans-serif',
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 500,
    lineHeight: '22.5px'
  }
};
export default typography;